/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum DocumentType {
  LEASE_AGREEMENT = 'LeaseAgreement',
  LEASE_ADDITIONAL_AGREEMENTS = 'LeaseAdditionalAgreements',
  LEASE_SPECIAL_USE_AGREEMENT = 'LeaseSpecialUseAgreement',
  LEASE_PREVIOUS_AGREEMENT = 'LeasePreviousAgreement',
  LEASE_SUPPLEMENT = 'LeaseSupplement',
  LEASE_RENT_INVOICE = 'LeaseRentInvoice',
  LEASE_RENT_DUNNING_NOTICE = 'LeaseRentDunningNotice',
  LEASE_RENT_INDEX_INVOICE = 'LeaseRentIndexInvoice',
  LEASE_RENT_INDEX_LETTER = 'LeaseRentIndexLetter',
  LEASE_RENT_ADJUSTMENT = 'LeaseRentAdjustment',
  LEASE_TERMINATION_LETTER = 'LeaseTerminationLetter',
  LEASE_OPTION_OR_EXTENSION_LETTER = 'LeaseOptionOrExtensionLetter',
  LEASE_CONTRACT_MISC_CORRESPONDENCE = 'LeaseContractMiscCorrespondence',
  LEASE_HANDOVER_REPORT = 'LeaseHandoverReport',
  LEASE_RETURN_HANDOVER_REPORT = 'LeaseReturnHandoverReport',
  LEASE_OWNER_OR_CONTACT_CHANGE = 'LeaseOwnerOrContactChange',
  LEASE_CONTACT_DATA = 'LeaseContactData',
  LEASE_SECURITY_DEPOSIT = 'LeaseSecurityDeposit',
  MISCELLANEOUS_CORRESPONDENCE = 'MiscellaneousCorrespondence',
  OPERATING_COST_INVOICE = 'OperatingCostInvoice',
  OPERATING_COST_CORRECTION = 'OperatingCostCorrection',
  OPERATING_COST_CREDIT_NOTE = 'OperatingCostCreditNote',
  OPERATING_COST_SUPPORTING_DOCUMENTS = 'OperatingCostSupportingDocuments',
  OPERATING_COST_OBJECTION_LETTER = 'OperatingCostObjectionLetter',
  OPERATING_COST_MISC_CORRESPONDENCE = 'OperatingCostMiscCorrespondence',
  FMCONTRACT = 'FMContract',
  FMINVOICE = 'FMInvoice',
  FMDUNNING_NOTICE = 'FMDunningNotice',
  FMINSPECTION_REPORT = 'FMInspectionReport',
  FMPLANS = 'FMPlans',
  FMPHOTOS = 'FMPhotos',
  FMOFFER = 'FMOffer',
  FMINCIDENT_REPORT = 'FMIncidentReport',
  FMCONTACT_DATA = 'FMContactData',
  FMMISC_CORRESPONDENCE = 'FMMiscCorrespondence',
}
